import React, { useEffect, useState } from 'react'
import { addToCart, bookMarkCourse, courseLesson, courseListing, courseRatingReview, trendingCourseList } from '../../api/apiHandler'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { decryption, encryption } from '../../common/enc_dec';
import { Loading } from '../../components/loading/loading';
import { formatDuration, isValidImageUrl } from '../../common/utilityFunctions';
import { showErrorMessage, showSuccessMessage } from '../../common/notification';
import { useDispatch, useSelector } from 'react-redux';
import { addCourseToCart } from '../../slices/cartPaymentSlice';
import ReactPaginate from "react-paginate";
import { useTranslation } from 'react-i18next';
import '../../i18';

export const CourseDetails = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const paramsData = decryption(decodeURIComponent(params.data));
    const [isLoading, setIsLoading] = useState(true);
    const [hasMounted, setHasMounted] = useState(false);
    const [courseData, setCourseData] = useState({});
    const [lessionData, setLessionData] = useState([]);
    const [ratingPercentages, setRatingPercentages] = useState({ 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 });
    const [isBookmarkChange, setIsBookmarkChange] = useState(false);
    const dispatch = useDispatch();
    const [similarCourses, setSimilarCourses] = useState([]);
    const [trendingCourse, setTrendingCourse] = useState([]);
    const [pageToken, setPageToken] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [cartCourses, setCartCourses] = useState([]);
    const cartData = useSelector((state) => state.cart.cartData);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!hasMounted) setIsLoading(true);
                const response = await courseListing({
                    language: paramsData.language,
                    id: paramsData.id
                });
                const lessionResponse = await courseLesson({
                    language: paramsData.language,
                    course_id: paramsData.id
                });
                const reviewResponse = await courseRatingReview({
                    course_id: paramsData.id
                });
                getSimilarCourse();
                if (reviewResponse.code === 200 || reviewResponse.code === 404) {
                    const ratings = reviewResponse.data.data;
                    calculateRatings(ratings);
                }
                if (response.code === 200) {
                    setCourseData(response.data);
                }
                if (lessionResponse.code === 200 || lessionResponse.code === 404) {
                    setLessionData(lessionResponse.data.data);
                }
            }
            catch (err) {
                console.log('err: ', err);
            }
            finally {
                if (!hasMounted) setIsLoading(false);
                setHasMounted(true);
            }
        }
        fetchData();
    }, [isBookmarkChange, pageToken, JSON.stringify(paramsData)]);

    useEffect(() => {
        trendingCourses();
    }, [])
    const trendingCourses = async () => {
        const trendingCourseResponse = await trendingCourseList({
            language: paramsData.language,
        })
        if (trendingCourseResponse?.code == 200) {
            setTrendingCourse([trendingCourseResponse?.data?.data[0]])
        }
    }
    const handleBookmark = () => {
        const addBookmark = async () => {
            const response = await bookMarkCourse({
                course_id: courseData?.id
            });
            if (response.code === 200) {
                showSuccessMessage(response.message);
                setIsBookmarkChange(prevValue => !prevValue);
            }
        }
        addBookmark();
    }

    const handleAddToCart = () => {
        dispatch(
            addCourseToCart({
                payload: {
                    course_id: courseData?.id
                }
            })
        )
            .then((response) => {
                if (response.payload.code === 200) {
                    showSuccessMessage(response.payload.message);
                    setCartCourses(prevCourses => [...prevCourses, courseData.id]);
                }
                if (response.payload.code === 400) {
                    showErrorMessage(response.payload.message);
                }
            });
    }

    const handleBuyNow = () => {
        const courseExistsInCart = cartData?.cart_details?.data?.some(
            (item) => item.course_id === courseData?.id
        );

        if (courseExistsInCart) {
            navigate('/cart');
        } else {
            showErrorMessage(t('pleaseAddToCartFirst'));
        }
    };

    function calculateRatings(ratings) {
        const totalRatings = ratings.length;
        const calculatedPercentages = {};
        let ratingObj = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
        if (totalRatings > 0) {
            ratings.map(ratingDetails => {
                let floorRating = Math.floor(ratingDetails.rating);
                ratingObj[floorRating]++;
            });
            Object.keys(ratingObj).forEach((rating) => {
                calculatedPercentages[rating] = ((ratingObj[rating] / totalRatings) * 100).toFixed(0);
            });
            setRatingPercentages(calculatedPercentages);
        }
    }

    const getSimilarCourse = async () => {
        const response = await courseListing({
            category_id: paramsData.category_id,
            language: paramsData.language,
            is_purchage: false,
            page: pageToken,
            limit: 3
        });
        if (response?.code == 200) {
            setSimilarCourses(response?.data?.data);
            setTotalPage(response.data.paging);
        }
        else {
            setSimilarCourses("");
        }
        setIsLoading(false);
    };

    const handlePageClick = (e) => {
        setPageToken(e.selected + 1)
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="PageTitleBox">
                            <h2 className="PageTitleHeading">{t('courseDetailsHeading')}</h2>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="course-course-detaila-inner">
                            <div className="details-inner">
                                {courseData?.assign_trainer?.length > 0 && (
                                    <div className="emt-user">
                                        <span className="u-thumb">
                                            <img src={courseData?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'} alt="img" />
                                        </span>
                                        <span className="align-self-center">{courseData?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                    </div>
                                )}
                                <h3 className="title">
                                    <a href="course-details.html">{courseData?.course_category?.name}</a>
                                </h3>
                            </div>
                            <div className="thumb">
                                <img
                                    width={"100%"} height={315} className='object-fit-cover'
                                    src={
                                        isValidImageUrl(courseData.image)
                                            ? courseData.image
                                            : `${process.env.PUBLIC_URL}/assets/img/other/course.jpg`
                                    }
                                    alt={courseData?.name}
                                />
                            </div>
                            <div className="course-details-nav-tab text-center">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item">
                                        <a
                                            className="nav-link active"
                                            id="tab1-tab"
                                            data-toggle="tab"
                                            href="#tab1"
                                            role="tab"
                                            aria-controls="tab1"
                                            aria-selected="true"
                                        >
                                            {t('Description')}
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            id="tab2-tab"
                                            data-toggle="tab"
                                            href="#tab2"
                                            role="tab"
                                            aria-controls="tab2"
                                            aria-selected="false"
                                        >
                                            {t('courseList')}
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            id="tab4-tab"
                                            data-toggle="tab"
                                            href="#tab4"
                                            role="tab"
                                            aria-controls="tab4"
                                            aria-selected="false"
                                        >
                                            {t('review')}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="tab-content" id="myTabContent">
                                <div
                                    className="tab-pane fade show active"
                                    id="tab1"
                                    role="tabpanel"
                                    aria-labelledby="tab1-tab"
                                >
                                    <div className="course-details-content">
                                        <h4>{courseData?.name}</h4>
                                        <p>
                                            {courseData?.description}
                                        </p>
                                        {/* <div className="row pt-4">
                                            <div className="col-sm-6">
                                                <ul className="single-list-wrap">
                                                    <li className="single-list-inner style-check-box">
                                                        <i className="fa fa-check" /> Metus interdum metus
                                                    </li>
                                                    <li className="single-list-inner style-check-box">
                                                        <i className="fa fa-check" /> Ligula cur maecenas
                                                    </li>
                                                    <li className="single-list-inner style-check-box">
                                                        <i className="fa fa-check" /> Fringilla nulla
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="col-sm-6 mt-3 mt-sm-0">
                                                <ul className="single-list-wrap">
                                                    <li className="single-list-inner style-check-box">
                                                        <i className="fa fa-check" /> Metus interdum metus
                                                    </li>
                                                    <li className="single-list-inner style-check-box">
                                                        <i className="fa fa-check" /> Ligula cur maecenas
                                                    </li>
                                                    <li className="single-list-inner style-check-box">
                                                        <i className="fa fa-check" /> Fringilla nulla
                                                    </li>
                                                </ul>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div
                                    className="tab-pane fade"
                                    id="tab2"
                                    role="tabpanel"
                                    aria-labelledby="tab2-tab"
                                >
                                    <div className="course-details-content">
                                        <ul className="course-details-content-ul">
                                            {
                                                lessionData && lessionData.length > 0 && lessionData.map((lession, index) => (
                                                    <li className="course-details-content-li" key={lession?.id}>
                                                        <a
                                                            href="javascript:void(0)"
                                                            className="course-details-content-link"
                                                            onClick={() => { showErrorMessage(t("purchaseCourseForVideo")) }}
                                                        >
                                                            <div className="CourseLinkOne">
                                                                <span className="CourseNumber">{(index + 1).toString().padStart(2, '0')}</span>
                                                                <div>
                                                                    <p className="Coursename">{lession?.title}</p>
                                                                    <p className="CourseTime">{formatDuration(lession?.duration, t)}</p>
                                                                </div>
                                                            </div>
                                                            <div className="CoursePlayBtn">
                                                                <img
                                                                    src={process.env.PUBLIC_URL + "/assets/img/icon/playicon.svg"}
                                                                    alt="playicon"
                                                                    className="img-cover"
                                                                />
                                                            </div>
                                                        </a>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                        {lessionData.length === 0 && (
                                            <p>{t('noLesson')}</p>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className="tab-pane fade"
                                    id="tab4"
                                    role="tabpanel"
                                    aria-labelledby="tab4-tab"
                                >
                                    <div className="ratings-list-inner mb-4">
                                        <div className="row">
                                            <div className="col-md-4 align-self-center text-center">
                                                <div className="total-avarage-rating">
                                                    <h2>{courseData?.avg_review}</h2>
                                                    <div className="rating-inner">
                                                        {
                                                            [...Array(Math.floor(courseData?.avg_review))].map((_, index) => (
                                                                <i key={`full-${index}`} className="fa fa-star" />
                                                            ))
                                                        }
                                                        {courseData?.avg_review % 1 >= 0.5 ? (<i className="fa fa-star-half-o" />) : (<></>)}
                                                        {[...Array(5 - Math.floor(courseData?.avg_review) - (courseData?.avg_review % 1 >= 0.5 ? 1 : 0))].map((_, index) => (
                                                            <i key={`empty-${index}`} className="fa fa-star-o" />
                                                        ))}
                                                    </div>
                                                    <p> {t('avgRating', { field: courseData?.avg_review })} </p>
                                                </div>
                                            </div>
                                            <div className="col-md-8">
                                                <ul>
                                                    {
                                                        Object.keys(ratingPercentages).sort((a, b) => b - a).map((rating) => (
                                                            <li key={rating}>
                                                                <a href="javascript:void(0)">
                                                                    <span className="counter-label">
                                                                        <i className="fa fa-star" />{rating}
                                                                    </span>
                                                                    <span className="progress-bar-inner">
                                                                        <span className="progress">
                                                                            <span
                                                                                className="progress-bar"
                                                                                role="progressbar"
                                                                                aria-valuenow={ratingPercentages[rating]}
                                                                                aria-valuemin={0}
                                                                                aria-valuemax={100}
                                                                                style={{ width: `${ratingPercentages[rating]}%` }}
                                                                            />
                                                                        </span>
                                                                    </span>
                                                                    <span className="counter-count">{ratingPercentages[rating]}%</span>
                                                                </a>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="td-sidebar">
                            <div className="widget widget_feature">
                                <div className="CourseDetaisFlexBox">
                                    <h4 className="widget-title m-0">{t('courseFeatures')}</h4>
                                    <span className="BookmartlinkPage">
                                        <i className={`fa-bookmark ${courseData?.user_favorite_course[0]?.is_favorite ? "fa-solid" : "fa-regular"}`} onClick={handleBookmark} />
                                    </span>
                                </div>
                                <ul>
                                    <li>
                                        <i className="fa fa-user" />
                                        <span>{t('enrolled')} :</span> {courseData?.total_purchage} {t('students')}
                                    </li>
                                    <li>
                                        <i className="fa fa-clock-o" />
                                        <span>{t('duration')} :</span> {formatDuration(courseData?.duration, t)}
                                    </li>
                                    <li>
                                        <i className="fa fa-clipboard" />
                                        <span>{t('lectures')} :</span> {courseData?.total_lession}
                                    </li>
                                    <li>
                                        <i className="fa fa-clone" />
                                        <span>{t('categories')} :</span> {courseData?.course_category?.name}
                                    </li>
                                    <li>
                                        <i className="fa-solid fa-language"></i>
                                        <span>{t('language')} :</span> {courseData?.language}
                                    </li>
                                    {
                                        courseData?.assign_trainer && courseData?.assign_trainer.length > 0 && (
                                            <li>
                                                <i className="fa fa-clipboard" />
                                                <span>{t('instructor')} :</span> {courseData?.assign_trainer[0]?.trainer_details?.full_name}
                                            </li>
                                        )
                                    }
                                </ul>
                                <div className="price-wrap text-center">
                                    <h5>
                                        {t('price')} :<span>₹{courseData?.price}</span>
                                    </h5>
                                    <div className='d-flex gap-2'>
                                        <button className="btn btn-base btn-radius" onClick={handleBuyNow}>
                                            {t('buyNow')}
                                        </button>
                                        <button className="btn btn-base btn-radius" onClick={handleAddToCart}>
                                            {t('addToCart')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {trendingCourse?.filter(Boolean).length > 0 && (
                                <div className="widget">
                                    <h4 className="widget-title">{t('trendingCourse')}</h4>
                                    {trendingCourse.map((course) => (
                                        <div className="single-course-inner" key={course?.id}>
                                            <Link
                                                to={course?.is_purchage
                                                    ? '/course'
                                                    : `/course-details/${encodeURIComponent(encryption({
                                                        id: course?.id,
                                                        category_id: course?.category_id,
                                                        language: course?.language
                                                    }, true))}`}
                                                className="thumb"
                                            >
                                                <img src={course?.image} alt="img" />
                                            </Link>
                                            <div className="details">
                                                <Link
                                                    to={course?.is_purchage
                                                        ? '/course'
                                                        : `/course-details/${encodeURIComponent(encryption({
                                                            id: course?.id,
                                                            category_id: course?.category_id,
                                                            language: course?.language
                                                        }, true))}`}
                                                    className="details-inner"
                                                >
                                                    <div className="d-flex justify-content-between mb-3">
                                                        <p className="CardMainHeading">{course?.course_category?.name}</p>
                                                        {course?.assign_trainer && course?.assign_trainer?.length > 0 && (
                                                            <div className="emt-user">
                                                                <span className="u-thumb">
                                                                    <img src={course?.assign_trainer[0]?.trainer_details?.image} alt="img" />
                                                                </span>
                                                                <span className="align-self-center">{course?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <h6 className="CardMainSubHeading text-truncate-2">
                                                        {course?.name}
                                                    </h6>
                                                    <div className="LassonsMain">
                                                        <ul className="LassonsUl">
                                                            <li className="LassonsLi">
                                                                <p className="Lessonstext">{course?.total_lession} {t('lessons')}</p>
                                                            </li>
                                                            <li className="dots" />
                                                            <li className="LassonsLi">
                                                                <p className="Lessonstext">{formatDuration(course?.duration, t)}</p>
                                                            </li>
                                                            <li className="dots" />
                                                            <li className="LassonsLi">
                                                                <p className="Lessonstext">
                                                                    <strong>{course?.validity}</strong> {t('daysValidity')}
                                                                </p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </Link>
                                                <div className="emt-course-meta">
                                                    <div className="LassonsCardFooter">
                                                        <ul className="LassonsCardFooterUl">
                                                            <li className="LassonsCardFooterLi">
                                                                <div className="rating">
                                                                    <i className="fa fa-star" /> {course?.avg_review}
                                                                    <span>({course?.total_review})</span>
                                                                </div>
                                                            </li>
                                                            <li className="LassonsCardFooterLi">
                                                                <div className="price">
                                                                    <span>₹{course?.price}</span>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    {similarCourses && similarCourses.filter(courseItem => courseItem.id !== paramsData.id && !courseItem.is_purchage).length > 0 &&
                        <h4 className='text-center'>{t('similarCourses')}</h4>
                    }
                    {similarCourses && similarCourses.length > 0 && similarCourses.filter(courseItem => courseItem.id !== paramsData.id && !courseItem.is_purchage).map((courseItem) => (
                        <div className="col-lg-4 col-md-6 CourseGride" key={courseItem.id}>
                            <div className="single-course-inner">
                                <Link to={`/course-details/${encodeURIComponent(encryption({
                                    id: courseItem.id, category_id: courseItem.category_id, language: courseItem.language
                                }, true))}`} className="thumb">
                                    <img src={courseItem.image} alt="Course" />
                                </Link>
                                <div className="details">
                                    <Link to={`/course-details/${encodeURIComponent(encryption({
                                        id: courseItem.id, category_id: courseItem.category_id, language: courseItem.language
                                    }, true))}`} className="details-inner">
                                        <div className="d-flex justify-content-between mb-3">
                                            <p className="CardMainHeading">{courseItem?.course_category.name}</p>
                                            {courseItem?.assign_trainer && courseItem?.assign_trainer[0] ? (
                                                <div className="emt-user">
                                                    <span className="u-thumb">
                                                        <img src={courseItem?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'} alt="author" />
                                                    </span>
                                                    <span className="align-self-center">{courseItem?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                                </div>
                                            ) : (
                                                <div className="emt-user"></div>
                                            )}
                                        </div>
                                        <h6 className="CardMainSubHeading text-truncate-2">{courseItem.name}</h6>
                                        <div className="LassonsMain">
                                            <ul className="LassonsUl">
                                                <li className="LassonsLi">
                                                    <p className="Lessonstext">{courseItem.total_lession} {t('lessons')}</p>
                                                </li>
                                                <li className="dots" />
                                                <li className="LassonsLi">
                                                    <p className="Lessonstext">{formatDuration(courseItem.duration, t)}</p>
                                                </li>
                                                <li className="dots" />
                                                <li className="LassonsLi">
                                                    <p className="Lessonstext">
                                                        <strong>{courseItem.validity}</strong> {t('daysValidity')}
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </Link>
                                    <div className="emt-course-meta">
                                        <div className="LassonsCardFooter">
                                            <ul className="LassonsCardFooterUl">
                                                <li className="LassonsCardFooterLi">
                                                    <div className="rating">
                                                        <i className="fa fa-star" /> {courseItem.avg_review}
                                                        <span>({courseItem.total_review})</span>
                                                    </div>
                                                </li>
                                                <li className="LassonsCardFooterLi">
                                                    <div className="price">
                                                        <span>₹{courseItem.price}</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {similarCourses && similarCourses.filter(courseItem => courseItem.id !== paramsData.id && !courseItem.is_purchage).length > 0 && (
                        <ReactPaginate
                            className='pagination mt-4'
                            breakLabel="..."
                            nextLabel={`${t('next')} >`}
                            previousLabel={`< ${t('Previous')} `}
                            renderOnZeroPageCount={null}
                            onPageChange={handlePageClick}
                            pageCount={Math.ceil(totalPage.total / totalPage.page_limit)}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}